import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/utils/routes';

const ScanButton = ({ withWrapper }) => {
  const Button = (
    <Link to={routes.scan}>
      <button
        type='button'
        className='piece-overview-action-button piece-overview-action-button--scan'
      >
        <FontAwesomeIcon icon={faQrcode} className='piece-overview-action-button__icon' />
        New Scan
      </button>
    </Link>
  );

  if (withWrapper) {
    return <div className='text-center mt15'>{Button}</div>;
  }

  return Button;
};

ScanButton.propTypes = {
  withWrapper: PropTypes.bool,
};

ScanButton.defaultProps = {
  withWrapper: true,
};

export default ScanButton;
